import { cn } from "@gymflow/helpers";
import { memberClubs } from "apps/member-app/builder/environments/meta-data";

import { usePortalRoutes } from "../../hooks";

export function AppStoreButton({ className }: { className?: string }) {
  const { routeId, brand } = usePortalRoutes();
  const brandedApp = Object.values(memberClubs).find((e) => {
    return e.clubRoute === routeId || e.brand === brand;
  });
  const appStoreLink = brandedApp
    ? `https://apps.apple.com/us/app/gymflow/id${brandedApp.apple.appId}`
    : undefined;
  return (
    <a
      href={
        appStoreLink ??
        "https://apps.apple.com/us/app/gymflow-members/id1631161012"
      }
      target="_blank"
      rel="noreferrer"
      className={cn(
        "h-10 border border-gray-950 dark:border-gray-25 rounded-[0.625rem] px-4 flex items-center self-center text-center justify-center",
        className,
      )}
    >
      <svg
        width="101"
        height="26"
        viewBox="0 0 101 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M72.5259 11.201V13.492H71.0899V14.9944H72.5259V20.0994C72.5259 21.8426 73.3145 22.5398 75.2984 22.5398C75.647 22.5398 75.9791 22.4983 76.2696 22.4485V20.9627C76.0206 20.9876 75.8628 21.0042 75.5889 21.0042C74.7007 21.0042 74.3106 20.5892 74.3106 19.6429V14.9944H76.2696V13.492H74.3106V11.201H72.5259Z"
          fill="#0C111D"
          className="dark:fill-gray-25 fill-gray-950"
        />
        <path
          d="M81.3234 22.6644C83.9631 22.6644 85.5817 20.8963 85.5817 17.9661C85.5817 15.0525 83.9548 13.2762 81.3234 13.2762C78.6838 13.2762 77.0568 15.0525 77.0568 17.9661C77.0568 20.8963 78.6755 22.6644 81.3234 22.6644ZM81.3234 21.0789C79.7712 21.0789 78.8996 19.9417 78.8996 17.9661C78.8996 16.0071 79.7712 14.8616 81.3234 14.8616C82.8674 14.8616 83.7473 16.0071 83.7473 17.9661C83.7473 19.9334 82.8674 21.0789 81.3234 21.0789Z"
          fill="#0C111D"
          className="dark:fill-gray-25 fill-gray-950"
        />
        <path
          d="M86.9666 22.49H88.7513V17.1526C88.7513 15.8826 89.7059 15.0276 91.0589 15.0276C91.3743 15.0276 91.9056 15.0857 92.055 15.1356V13.3758C91.8641 13.326 91.5238 13.3011 91.2581 13.3011C90.0794 13.3011 89.075 13.9485 88.8177 14.8367H88.6849V13.4505H86.9666V22.49Z"
          fill="#0C111D"
          className="dark:fill-gray-25 fill-gray-950"
        />
        <path
          d="M96.4863 14.7952C97.8061 14.7952 98.6694 15.7166 98.7109 17.136H94.1455C94.2451 15.7249 95.1665 14.7952 96.4863 14.7952ZM98.7026 20.0496C98.3706 20.7552 97.6318 21.1453 96.5527 21.1453C95.125 21.1453 94.2036 20.1409 94.1455 18.5555V18.4559H100.529V17.8333C100.529 14.9944 99.0097 13.2762 96.4946 13.2762C93.9463 13.2762 92.3276 15.1107 92.3276 17.9993C92.3276 20.888 93.9131 22.6644 96.5029 22.6644C98.5698 22.6644 100.014 21.6683 100.421 20.0496H98.7026Z"
          fill="#0C111D"
          className="dark:fill-gray-25 fill-gray-950"
        />
        <path
          d="M60.8223 19.1519C60.96 21.3716 62.8098 22.7912 65.5629 22.7912C68.5053 22.7912 70.3464 21.3028 70.3464 18.9282C70.3464 17.0612 69.2968 16.0288 66.7502 15.4352L65.3822 15.0996C63.7647 14.7211 63.1109 14.2135 63.1109 13.3273C63.1109 12.2088 64.1261 11.4775 65.6489 11.4775C67.0943 11.4775 68.0923 12.1916 68.273 13.3359H70.1486C70.0367 11.2452 68.1956 9.77405 65.6747 9.77405C62.9646 9.77405 61.1579 11.2452 61.1579 13.4564C61.1579 15.2803 62.1817 16.3643 64.4272 16.8892L66.0275 17.2763C67.6707 17.6635 68.3934 18.2313 68.3934 19.1777C68.3934 20.2789 67.2578 21.0791 65.7091 21.0791C64.0487 21.0791 62.8958 20.3306 62.7323 19.1519H60.8223Z"
          fill="#0C111D"
          className="dark:fill-gray-25 fill-gray-950"
        />
        <path
          d="M42.335 13.3011C41.1065 13.3011 40.044 13.9153 39.4961 14.9446H39.3633V13.4505H37.6451V25.4949H39.4297V21.1204H39.5708C40.044 22.075 41.065 22.6395 42.3516 22.6395C44.6343 22.6395 46.087 20.8382 46.087 17.9661C46.087 15.094 44.6343 13.3011 42.335 13.3011ZM41.8287 21.0374C40.3345 21.0374 39.3965 19.8587 39.3965 17.9744C39.3965 16.0818 40.3345 14.9031 41.837 14.9031C43.3477 14.9031 44.2525 16.0569 44.2525 17.9661C44.2525 19.8836 43.3477 21.0374 41.8287 21.0374Z"
          fill="#0C111D"
          className="dark:fill-gray-25 fill-gray-950"
        />
        <path
          d="M52.3318 13.3011C51.1033 13.3011 50.0408 13.9153 49.4929 14.9446H49.3601V13.4505H47.6419V25.4949H49.4265V21.1204H49.5676C50.0408 22.075 51.0618 22.6395 52.3484 22.6395C54.6311 22.6395 56.0838 20.8382 56.0838 17.9661C56.0838 15.094 54.6311 13.3011 52.3318 13.3011ZM51.8255 21.0374C50.3313 21.0374 49.3933 19.8587 49.3933 17.9744C49.3933 16.0818 50.3313 14.9031 51.8338 14.9031C53.3445 14.9031 54.2493 16.0569 54.2493 17.9661C54.2493 19.8836 53.3445 21.0374 51.8255 21.0374Z"
          fill="#0C111D"
          className="dark:fill-gray-25 fill-gray-950"
        />
        <path
          d="M34.4431 22.49H36.4907L32.0083 10.0752H29.9348L25.4524 22.49H27.4312L28.5755 19.1949H33.3074L34.4431 22.49ZM30.8726 12.3293H31.0189L32.817 17.5774H29.0659L30.8726 12.3293Z"
          fill="#0C111D"
          className="dark:fill-gray-25 fill-gray-950"
        />
        <path
          d="M26.6514 0.710938V6.69995H28.8137C30.5984 6.69995 31.6318 5.6001 31.6318 3.68677C31.6318 1.80249 30.5901 0.710938 28.8137 0.710938H26.6514ZM27.5811 1.55762H28.71C29.9509 1.55762 30.6855 2.34619 30.6855 3.69922C30.6855 5.073 29.9634 5.85327 28.71 5.85327H27.5811V1.55762Z"
          fill="#0C111D"
          className="dark:fill-gray-25 fill-gray-950"
        />
        <path
          d="M34.7969 6.78711C36.1167 6.78711 36.9261 5.90308 36.9261 4.43799C36.9261 2.9812 36.1126 2.09302 34.7969 2.09302C33.4771 2.09302 32.6636 2.9812 32.6636 4.43799C32.6636 5.90308 33.4729 6.78711 34.7969 6.78711ZM34.7969 5.99438C34.0208 5.99438 33.585 5.42578 33.585 4.43799C33.585 3.4585 34.0208 2.88574 34.7969 2.88574C35.5689 2.88574 36.0088 3.4585 36.0088 4.43799C36.0088 5.42163 35.5689 5.99438 34.7969 5.99438Z"
          fill="#0C111D"
          className="dark:fill-gray-25 fill-gray-950"
        />
        <path
          d="M43.8182 2.18018H42.9259L42.1207 5.62915H42.0501L41.1205 2.18018H40.2655L39.3358 5.62915H39.2694L38.4601 2.18018H37.5553L38.8004 6.69995H39.7176L40.6473 3.37134H40.7179L41.6517 6.69995H42.5772L43.8182 2.18018Z"
          fill="#0C111D"
          className="dark:fill-gray-25 fill-gray-950"
        />
        <path
          d="M44.8458 6.69995H45.7382V4.05615C45.7382 3.35059 46.1574 2.91064 46.8173 2.91064C47.4772 2.91064 47.7926 3.27173 47.7926 3.99805V6.69995H48.685V3.77393C48.685 2.69897 48.1288 2.09302 47.1203 2.09302C46.4396 2.09302 45.9914 2.396 45.7714 2.89819H45.705V2.18018H44.8458V6.69995Z"
          fill="#0C111D"
          className="dark:fill-gray-25 fill-gray-950"
        />
        <path
          d="M50.0903 6.69995H50.9826V0.41626H50.0903V6.69995Z"
          fill="#0C111D"
          className="dark:fill-gray-25 fill-gray-950"
        />
        <path
          d="M54.3386 6.78711C55.6584 6.78711 56.4678 5.90308 56.4678 4.43799C56.4678 2.9812 55.6543 2.09302 54.3386 2.09302C53.0188 2.09302 52.2053 2.9812 52.2053 4.43799C52.2053 5.90308 53.0146 6.78711 54.3386 6.78711ZM54.3386 5.99438C53.5625 5.99438 53.1267 5.42578 53.1267 4.43799C53.1267 3.4585 53.5625 2.88574 54.3386 2.88574C55.1106 2.88574 55.5505 3.4585 55.5505 4.43799C55.5505 5.42163 55.1106 5.99438 54.3386 5.99438Z"
          fill="#0C111D"
          className="dark:fill-gray-25 fill-gray-950"
        />
        <path
          d="M59.1265 6.02344C58.6409 6.02344 58.2881 5.78687 58.2881 5.38013C58.2881 4.98169 58.5704 4.77002 59.1929 4.72852L60.2969 4.65796V5.03564C60.2969 5.59595 59.7989 6.02344 59.1265 6.02344ZM58.8982 6.77466C59.4917 6.77466 59.9856 6.51733 60.2554 6.06494H60.326V6.69995H61.1851V3.61206C61.1851 2.65747 60.5459 2.09302 59.4129 2.09302C58.3877 2.09302 57.6573 2.59106 57.566 3.36719H58.4292C58.5289 3.04761 58.8733 2.86499 59.3714 2.86499C59.9815 2.86499 60.2969 3.13477 60.2969 3.61206V4.0022L59.0726 4.07275C57.9976 4.13916 57.3916 4.60815 57.3916 5.42163C57.3916 6.24756 58.0267 6.77466 58.8982 6.77466Z"
          fill="#0C111D"
          className="dark:fill-gray-25 fill-gray-950"
        />
        <path
          d="M64.2132 6.77466C64.8358 6.77466 65.3629 6.47998 65.6327 5.98608H65.7032V6.69995H66.5582V0.41626H65.6659V2.89819H65.5995C65.3546 2.40015 64.8316 2.10547 64.2132 2.10547C63.0719 2.10547 62.3373 3.01025 62.3373 4.43799C62.3373 5.86987 63.0636 6.77466 64.2132 6.77466ZM64.4664 2.90649C65.2135 2.90649 65.6825 3.5 65.6825 4.44214C65.6825 5.38843 65.2176 5.97363 64.4664 5.97363C63.711 5.97363 63.2586 5.39673 63.2586 4.43799C63.2586 3.48755 63.7152 2.90649 64.4664 2.90649Z"
          fill="#0C111D"
          className="dark:fill-gray-25 fill-gray-950"
        />
        <path
          d="M72.3447 6.78711C73.6645 6.78711 74.4738 5.90308 74.4738 4.43799C74.4738 2.9812 73.6604 2.09302 72.3447 2.09302C71.0249 2.09302 70.2114 2.9812 70.2114 4.43799C70.2114 5.90308 71.0207 6.78711 72.3447 6.78711ZM72.3447 5.99438C71.5686 5.99438 71.1328 5.42578 71.1328 4.43799C71.1328 3.4585 71.5686 2.88574 72.3447 2.88574C73.1166 2.88574 73.5566 3.4585 73.5566 4.43799C73.5566 5.42163 73.1166 5.99438 72.3447 5.99438Z"
          fill="#0C111D"
          className="dark:fill-gray-25 fill-gray-950"
        />
        <path
          d="M75.655 6.69995H76.5474V4.05615C76.5474 3.35059 76.9666 2.91064 77.6265 2.91064C78.2864 2.91064 78.6018 3.27173 78.6018 3.99805V6.69995H79.4941V3.77393C79.4941 2.69897 78.938 2.09302 77.9294 2.09302C77.2488 2.09302 76.8005 2.396 76.5806 2.89819H76.5142V2.18018H75.655V6.69995Z"
          fill="#0C111D"
          className="dark:fill-gray-25 fill-gray-950"
        />
        <path
          d="M83.6039 1.05542V2.20093H82.8858V2.95215H83.6039V5.50464C83.6039 6.37622 83.9981 6.72485 84.9901 6.72485C85.1644 6.72485 85.3304 6.7041 85.4757 6.6792V5.93628C85.3512 5.94873 85.2723 5.95703 85.1353 5.95703C84.6913 5.95703 84.4962 5.74951 84.4962 5.27637V2.95215H85.4757V2.20093H84.4962V1.05542H83.6039Z"
          fill="#0C111D"
          className="dark:fill-gray-25 fill-gray-950"
        />
        <path
          d="M86.6735 6.69995H87.5658V4.0603C87.5658 3.37549 87.9726 2.91479 88.703 2.91479C89.3339 2.91479 89.6701 3.28003 89.6701 4.0022V6.69995H90.5624V3.78223C90.5624 2.70728 89.9689 2.09717 89.006 2.09717C88.3253 2.09717 87.848 2.40015 87.6281 2.90649H87.5575V0.41626H86.6735V6.69995Z"
          fill="#0C111D"
          className="dark:fill-gray-25 fill-gray-950"
        />
        <path
          d="M93.7814 2.85254C94.4414 2.85254 94.873 3.31323 94.8937 4.02295H92.611C92.6608 3.31738 93.1215 2.85254 93.7814 2.85254ZM94.8896 5.47974C94.7236 5.83252 94.3542 6.02759 93.8146 6.02759C93.1008 6.02759 92.6401 5.52539 92.611 4.73267V4.68286H95.8027V4.37158C95.8027 2.95215 95.0432 2.09302 93.7856 2.09302C92.5114 2.09302 91.7021 3.01025 91.7021 4.45459C91.7021 5.89893 92.4948 6.78711 93.7897 6.78711C94.8232 6.78711 95.5454 6.28906 95.7487 5.47974H94.8896Z"
          fill="#0C111D"
          className="dark:fill-gray-25 fill-gray-950"
        />
        <path
          d="M15.769 12.3008C15.7907 10.6198 16.6934 9.02922 18.1256 8.14876C17.2221 6.85844 15.7088 6.04034 14.1344 5.99108C12.4552 5.81482 10.8272 6.99591 9.97149 6.99591C9.09922 6.99591 7.78172 6.00858 6.36299 6.03777C4.51374 6.09751 2.78977 7.1489 1.89007 8.76564C-0.0439277 12.1141 1.39866 17.0351 3.25127 19.7417C4.17817 21.0671 5.26145 22.5475 6.6789 22.495C8.06596 22.4375 8.584 21.6105 10.2583 21.6105C11.9171 21.6105 12.4031 22.495 13.8493 22.4616C15.3377 22.4375 16.2754 21.1304 17.1698 19.7925C17.8358 18.8481 18.3483 17.8044 18.6882 16.7C16.9391 15.9602 15.771 14.2 15.769 12.3008Z"
          fill="#0C111D"
          className="dark:fill-gray-25 fill-gray-950"
        />
        <path
          d="M13.0373 4.21108C13.8489 3.23687 14.2487 1.98469 14.1518 0.720459C12.912 0.850679 11.7668 1.44324 10.9443 2.38007C10.14 3.2954 9.72143 4.52555 9.80056 5.74146C11.0408 5.75423 12.2601 5.17773 13.0373 4.21108Z"
          fill="#0C111D"
          className="dark:fill-gray-25 fill-gray-950"
        />
      </svg>
    </a>
  );
}
